import { useTranslation } from 'react-i18next'

import { Alert, Button, ButtonWithSpinner, CardTitle, Drawer, Loading, Text } from '@reveni-io/reveni-ui'

import ImportFileUploader from '@/common/components/ImportFileUploader/ImportFileUploader'
import ProcessSteps from '@/common/components/ProcessSteps'

import { getSteps } from './constants'
import * as Styles from './styles'

const ImportCreateRmasDrawer = ({
  onClose,
  show,
  onSelectFile,
  onDeleteFile,
  loading,
  file,
  error,
  onError,
  onImport,
  importing,
}) => {
  const { t } = useTranslation()

  return (
    <Drawer show={show} onClose={onClose} size="l" options={{ showHeaderActions: false }}>
      <Loading show={loading} height="350">
        <CardTitle>{t('Importar: Creación de RMAs')}</CardTitle>
        <Styles.Container>
          <Text>{t('Crea RMAs de forma masiva cargando un archivo CSV.')}</Text>
          <ProcessSteps steps={getSteps(t)} />
          <Text type="titleS">{t('Importar CSV')}</Text>
          <ImportFileUploader onSelectFile={onSelectFile} file={file} onDeleteFile={onDeleteFile} onError={onError} />
          {error && <Alert type="error">{t(error)}</Alert>}
          <Styles.ActionsContainer>
            <Button onClick={onClose} variant="outlined" fullWidth>
              {t('Cancelar')}
            </Button>
            <ButtonWithSpinner
              fullWidth
              onClick={onImport}
              defaultLabel={t('Importar')}
              loadingLabel={t('Importando')}
              loading={importing}
              disabled={importing || !file}
            />
          </Styles.ActionsContainer>
        </Styles.Container>
      </Loading>
    </Drawer>
  )
}

export default ImportCreateRmasDrawer
